const LISTAR_DADOS = (state, payload) => {
    state.items = payload
  }

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_GRUPO_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

const INSERIR_GRUPO = (state,  payload) => {
  state.items.push(payload)
}

const ATUALIZAR_GRUPO = (state, payload) => {
  state.items = state.items.map(grupo => {
    if(grupo.id === payload.id) {
      return payload;
    }
    return grupo
  })
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    INSERIR_GRUPO_SELECIONADO,
    INSERIR_GRUPO,
    ATUALIZAR_GRUPO
}